module.exports = __webpack_public_path__ + "media/images/pages/home_featured/contribute-sellphotos-icon-6771cc32264374ad6516c35a6ff16e02.png";